export const nonBajajFaq = (contactNumber)=>[
  {
    id: 1,
    title: 'Why has my loan expired?',
    description:
    `The loan expires when the agreed-upon period in the loan agreement ends. To continue enjoying the benefits, reopen your loan account in just 5 minutes. In case of any outstanding balance, kindly repay before the due date to avoid security sell-off.\n\nNote: Sell-off will be initiated to recover the outstanding balance and applied charges if repayment is not made before the due date. we will release the remaining securities within one month from the loan expiry date. For any query, feedback or support, call us or whatsapp us at ${contactNumber}.`,
  },
  {
    id: 2,
    title: 'What if I fail to repay outstanding balance?',
    description:
    `If you fail to repay the outstanding balance, including principal and charges, by the due date, the lender will initiate a portfolio sell-off process to recover the remaining amount.`
  },
  {
    id: 3,
    title: 'How to reopen my loan account?',
    description:
    'Reopen your loan swiftly in just 5 minutes and resume enjoying the benefits in three simple steps: complete KYC, set up the mandate, and sign agreement.',
  },
  {
    id: 4,
    title: 'What will happen to my securities?',
    description:
    'Your pledged securities will be automatically unpledged within 1 month from the loan expiry date if your remaining outstanding is ZERO.\n\nNote:\n1. Repay the outstanding amount to avoid securities sell-off.\n2. Contact support to unpledge your portfolio when the loan has expired.',
  }
];

export const bajajFaq = (contactNumber)=>[
  {
    id: 1,
    title: 'Why has my loan expired?',
    description:
    `The loan expires when the agreed-upon period in the loan agreement ends. To continue enjoying the benefits, renew your loan account in just 5 minutes. In case of any outstanding balance, kindly repay before the due date to avoid security sell-off.\n\nNote: Sell-off will be initiated to recover the outstanding balance and applied charges if repayment is not made before the due date. we will release the remaining securities within one month from the loan expiry date. For any query, feedback or support, call us or whatsapp us at ${contactNumber}.`,
  },
  {
    id: 2,
    title: 'What if I fail to repay outstanding balance?',
    description:
    `If you fail to repay the outstanding balance, including principal and charges, by the due date, the lender will initiate a portfolio sell-off process to recover the remaining amount.Following this, your remaining pledged portfolio will be unpledged within one month if you do not renew your loan.`
  },
  {
    id: 3,
    title: 'How to reopen my loan account?',
    description:
    'Reopen your loan swiftly in just 5 minutes and resume enjoying the benefits in three simple steps: complete KYC, set up the mandate, and sign agreement.',
  },
  {
    id: 4,
    title: 'What will happen to my securities?',
    description:
    'Your pledged securities will be automatically unpledged within 1 month from the loan expiry date if your remaining outstanding is ZERO.\n\nNote:\n1. Repay the outstanding amount to avoid securities sell-off.\n2. Contact support to unpledge your portfolio when the loan has expired.',
  }
];
